import { create } from 'zustand';

export interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: number;
  meta?: {
    elapsed?: string;
    source?: string;
    projectId?: string;
  };
  images?: string[];
}

interface ChatState {
  chats: Record<string, Message[]>;
  getMessages: (projectId: string) => Message[];
  addMessage: (projectId: string, msg: Message) => void;
  setMessages: (projectId: string, messages: Message[] | ((prev: Message[]) => Message[])) => void;
  clearMessages: (projectId: string) => void;
}

export const useChatStore = create<ChatState>((set, get) => ({
  chats: {},
  getMessages: (projectId) => get().chats[projectId] || [],
  addMessage: (projectId, msg) => set((state) => ({
    chats: {
      ...state.chats,
      [projectId]: [...(state.chats[projectId] || []), msg]
    }
  })),
  setMessages: (projectId, updater) => set((state) => {
    const prev = state.chats[projectId] || [];
    const _messages = typeof updater === 'function' ? updater(prev) : updater;
    return {
      chats: {
        ...state.chats,
        [projectId]: _messages
      }
    };
  }),
  clearMessages: (projectId) => set((state) => ({
    chats: {
      ...state.chats,
      [projectId]: []
    }
  })),
}));
